import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Async } from '@/shared/ui/Async';
import { Button } from '@/shared/ui/Button';
import { ApplicationStatusChip } from '@/shared/ui/StatusChip';
import { useUiStore } from '@/stores/ui.store';

import { coverageDatesText } from '../components/coverage-format';
import { useMyApplications, useWithdrawApplication } from '../hooks/use-coverage';

/** A provider's applications, with the ability to withdraw a pending one. */
export function MyApplicationsRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = useUiStore((s) => s.locale);
  const query = useMyApplications();
  const withdraw = useWithdrawApplication();

  return (
    <main className="page stack">
      <h1>{t('nav.applications')}</h1>
      <Async query={query} isEmpty={(l) => l.length === 0} emptyMessage={t('application.empty')}>
        {(applications) => (
          <div className="stack">
            {applications.map((application) => (
              <div key={application.id} className="card stack">
                <div className="row row--between">
                  <button
                    type="button"
                    className="btn btn--text"
                    onClick={() => navigate(`/requests/${application.requestId}`)}
                  >
                    <strong>{application.request?.masjidName ?? t('masjid.fallbackName')}</strong>
                  </button>
                  <ApplicationStatusChip status={application.status} />
                </div>
                {application.request ? (
                  <span>{coverageDatesText(locale, application.request)}</span>
                ) : null}
                {application.status === 'pending' ? (
                  <Button
                    variant="outline"
                    loading={withdraw.isPending}
                    onClick={() => withdraw.mutate(application.id)}
                  >
                    {t('application.withdraw')}
                  </Button>
                ) : null}
              </div>
            ))}
          </div>
        )}
      </Async>
    </main>
  );
}
